import * as React from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/util/cn';

/**
 * Key figures for a page, as ONE card split into columns by hairlines —
 * a summary strip, not a row of identical boxes.
 */
export function StatStrip({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  return (
    <div
      className={cn(
        'tile grid grid-cols-2 divide-divider xl:grid-cols-4 xl:divide-x',
        '[&>*:nth-child(odd)]:border-r [&>*:nth-child(odd)]:border-divider xl:[&>*]:border-r-0',
        className,
      )}
    >
      {children}
    </div>
  );
}

/** One figure: a quiet label, the number, an optional line of context. */
export function Stat({
  label,
  value,
  sub,
  loading,
  className,
}: {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  loading?: boolean;
  className?: string;
}): React.ReactElement {
  return (
    <div className={cn('flex flex-col gap-1.5 px-5 py-4', className)}>
      <span className="text-sm text-fg-muted">{label}</span>
      {loading === true ? (
        <Skeleton className="h-7 w-28" />
      ) : (
        <div className="text-2xl font-semibold tracking-tight text-fg tabular-nums">{value}</div>
      )}
      {sub !== undefined && loading !== true ? (
        <div className="text-xs text-fg-subtle">{sub}</div>
      ) : null}
    </div>
  );
}
